<template>
    <div>
            <p v-if="status_loading_data" :style="'padding:5px;background-color:' + status_bg">
                {{status_loading_data}}                 {{timer_text}}

            </p>

        <div id="chart-only" style="background-color:white">
            <component :height="height"
                       :width="width"
                       :distribution="distribution"
                       :stacked="stacked"
                       :text_size="text_size"
                       :is="actual_chart_type"
                       @chartClicked="chartClicked($event)"
                       @stackChartClicked="stackChartClicked($event)"
                       @barLabelClicked="barLabelClicked($event)"
                       :onClick="onClick" v-bind:chartData="dataset" :groups="groups"
                       :render_info="render_info"
                       :highlighted="highlighted"
                       :additional_filters="additional_filters"
                       :extent_id="extent_id"
                       v-if="is_render_ready"
            />
            <group-labels v-if="groups" :groups="groups" />
        </div>
    </div>
</template>
<script>

    //Import your chart component for each type
    import ChartPie from './ChartPie.vue';
    import ChartHorizontalBar from './ChartHorizontalBar.vue';
    import ChartBar from './ChartBar.vue';
    import ChartTreeMap from './ChartTreeMap.vue';
    import ChartTimeSeries from './ChartTimeSeries.vue';
    import TableHeatmap from './TableHeatmap.vue';
    import ChartScatter from './ChartScatter.vue';
    import ChartSankey from './ChartSankey.vue';
    import TablePervasiveness from "./TablePervasiveness";
    import ChartStripPlot from "./ChartStripPlot";
    import BigNumber from "./BigNumber";
    import ChartSunburst from "./ChartSunburst";
    import ChartIcicle from "./ChartIcicle";
    import TableCustom from "./TableCustom";
    import WordCloud from "./WordCloud";
    import ChartProportionalArea  from "./ChartProportionalArea.vue";
    import ChartStellar  from "./ChartStellar.vue";
    import ChartSitemap  from "./ChartSitemap.vue";
    import ChartBump  from "./ChartBump.vue";

    export default {
        name: "chartManager",
        components: {
            pie: ChartPie,
            bar: ChartBar,
            tableheatmap: TableHeatmap,
            pervasiveness: TablePervasiveness,
            horizontalbar: ChartHorizontalBar,
            treemap: ChartTreeMap,
            timeseries: ChartTimeSeries,
            scatter: ChartScatter,
            sankey: ChartSankey,
            strip_plot: ChartStripPlot,
            big_number: BigNumber,
            sunburst: ChartSunburst,
            icicle: ChartIcicle,
            table_custom: TableCustom,
            word_cloud: WordCloud,
            proportional_area: ChartProportionalArea,
            stellar: ChartStellar,
            sitemap: ChartSitemap,
            bump: ChartBump,
        },
        mounted() {
            this.actual_chart_type = this.chartType
            this.get_data()
        },
        props: ['chartType', 'height', 'width', 'text_size', 'onClick', 'endPoint', 'processedData', 'distribution', 'stacked', 'render_info', 'highlighted','additional_filters', 'extent_id','is_render_ready'],
        data() {
            return {
                dataset: null,
                groups: null,
                actual_chart_type: null, // We need to first load the data before changing the child chart type
                status_loading_data: "Chart data loading not yet started",
                status_bg: 'white',
                colors: null,
                chartMeta: [],
                timer_text: '',
                should_stop_timer: true,
            }
        },
        watch: {
            endPoint: function () {
                this.get_data()
            },
            processedData: function() {
                this.get_data()
            },
            additional_filters: function() {
                this.get_data()
                console.log('(In ChartManager watch additional_filters) additional_filters:')
                console.log(this.additional_filters)
            }
        },
        methods: {
            // Not sure this is ever called (but stackChartClicked() is
            // !!!! CONSIDER DELETING chartClicked()
            // Pie was still using this, but refactored on Dec 19, 2022
            chartClicked(payload) {
                this.$emit('chartClicked',payload);
            },
            stackChartClicked(payload) {
                if (this.chartType === "bar" && this.groups.group_names !== 'ungrouped') {
                    let index = payload['index']
                    let group_names = this.groups.group_names
                    let group_sizes = this.groups.bars_per_group
                    let max_index_passed_groups = 0
                    let found_group = null
                    group_names.forEach(function (group_name) {
                        max_index_passed_groups += group_sizes[group_name]
                        if (!found_group && max_index_passed_groups > index) {
                            found_group = group_name
                        }
                    })
                    payload['group_value'] = found_group
                }
                this.$emit('stackChartClicked',payload);
            },
            barLabelClicked(payload) {
                this.$emit('barLabelClicked',payload)
            },
            chartError(error) {
                this.$emit('chartError',error)
            },
            update_timer_text(seconds) {
                this.timer_text = ' (' + seconds.toString() + 's)'
            },
            stop_timer() {
                this.timer_text = ''
                this.should_stop_timer = true
            },
            check_if_should_stop_timer() {
                return this.should_stop_timer
            },
            start_timer() {
                let timeleft = 120
                this.should_stop_timer = false
                var queryTimer = setInterval(() => {
                    if ((timeleft <=0 ) || (this.check_if_should_stop_timer())) {
                        this.stop_timer()
                        clearInterval(queryTimer)
                    }
                    this.update_timer_text(timeleft)
                    timeleft -= 1;
                }, 1000);
            },
            get_data() {
                if (this.processedData) {
                    this.dataset = this.processedData
                    this.status_loading_data = null
                    this.status_bg = 'white'
                } else if (this.endPoint) {
                    this.start_timer()
                    this.status_loading_data = "Chart data loading started"
                    this.status_bg = '#dddddd'
                  console.log('(In ChartManager about to get chart data) additional_filters:')
                  console.log(this.additional_filters)
                    axios.get(this.endPoint, {
                        params: {
                          additional_filters: this.additional_filters ? JSON.stringify(this.additional_filters) : []
                        }
                    })
                        .then(response => {
                            this.stop_timer()
                            this.status_loading_data = null
                            if (response.data.hasOwnProperty('error_class')) {
                                this.chartError(response.data)
                            } else {
                                this.dataset = response.data.chartjs ? response.data.chartjs : response.data
                                if (response.data.hasOwnProperty('groups')) {
                                    this.groups = response.data.groups
                                } else {
                                    this.groups = null
                                }
                              if (this.dataset.hasOwnProperty('meta')) {
                                this.chartMeta = this.dataset.meta
                                this.$emit('chartMetaLoaded',{meta: this.chartMeta});
                              } else {
                                this.chartMeta = null
                              }
                              if (response.data.hasOwnProperty('colors')) {
                                this.colors = response.data.colors
                                this.$emit('colorsLoaded',{colors: this.colors});
                              } else {
                                this.colors = null
                              }
                              if (this.dataset) {
                                this.$emit('dataLoaded')
                              }
                                this.actual_chart_type = this.chartType
                            }
                        })
                        .catch(error => {
                            this.stop_timer()
                            this.dataset = {
                                "labels": ["NO DATA"],
                                "datasets":
                                    [{
                                        "label": "count",
                                        "data": [0]
                                    }]
                            }
                            console.log(error.response.data.message)
                            this.status_loading_data = error.response.data.message
                            this.status_bg = '#FFBABA'
                        })
                }
            }
        }
    }
</script>
